angular.module("UI8.components").component("announcement", {
  template: `<div class="announcement" ng-if="$ctrl.isVisible && $ctrl.ckyReady" ng-style="{'bottom': $ctrl.cookieyesExist ? '76px' : '16px'}">
      <div class="announcement__preview">
        <a href="https://drop.ui8.net" target="_blank">
          <img src="/img/announcement/drop.avif" alt="Introducing Drop">
        </a>
        <button class="announcement__close" ng-click="$ctrl.close()"></button>
      </div>
      <div class="announcement__content">
        <div class="announcement__title">Introducing Drop</div>
        <div class="announcement__text">3D & Animation Studio for designers. 3D mockups, animations & exports all in your browser.</div>
        <a class="btn" href="https://drop.ui8.net" target="_blank">
          Learn more
        </a>
      </div>
    </div>`,

  controller: function ($rootScope, $location, $timeout) {
    var ctrl = this;

    function updateVisibility() {
      ctrl.isVisible =
        !localStorage.getItem("visible-drop-announcement") &&
        !$location.path().startsWith("/products/all-access-pass") &&
        !$location.path().startsWith("/account");
    }

    ctrl.$onInit = function () {
      updateVisibility();
      ctrl.ckyReady = false;
      ctrl.cookieyesExist = false;

      function resolveCky() {
        ctrl.cookieyesExist = !!document.querySelector(
          ".cky-btn-revisit-wrapper"
        );
        ctrl.ckyReady = true;
        $rootScope.$apply();
      }

      document.addEventListener("cookieyes", resolveCky, { once: true });
      $timeout(resolveCky, 1000);

      $rootScope.$watch(function () {
        return $location.path();
      }, updateVisibility);
    };

    ctrl.close = function () {
      ctrl.isVisible = false;
      localStorage.setItem("visible-drop-announcement", false);
    };
  },

  bindings: {},
});
